export const EMISSOR_BENEFITS_ONBOARDING_TOUR_STEP_SELECTORS = [
    '[data-benefits-onboarding-anchor="emissor-orders"]',
    '[data-benefits-onboarding-anchor="emissor-see-all"]',
    '[data-benefits-onboarding-anchor="emissor-new-recharge"]',
    '[data-benefits-onboarding-anchor="emissor-credit-date"]',
    '[data-benefits-onboarding-anchor="emissor-order-actions"]',
    '[data-benefits-onboarding-anchor="emissor-tracking"]',
    '[data-benefits-onboarding-anchor="emissor-contracted-benefits"]',
    '[data-benefits-onboarding-anchor="emissor-employees"]',
];
export const EMISSOR_BENEFITS_ONBOARDING_TOUR_ORDER_ACTIONS_STEP_INDEX = 4;
const EMISSOR_ORDER_ACTIONS_MENU_SELECTOR = '[data-testid$="Order0OptionsMenu"]';
const EMISSOR_ORDER_ACTIONS_TRIGGER_SELECTOR = '[data-testid$="Order0OptionsTrigger"]';
export function resolveEmissorBenefitsOnboardingTourTarget(stepIndex) {
    if (stepIndex !== EMISSOR_BENEFITS_ONBOARDING_TOUR_ORDER_ACTIONS_STEP_INDEX) {
        return null;
    }
    return document.querySelector(EMISSOR_ORDER_ACTIONS_MENU_SELECTOR);
}
export const EMISSOR_BENEFITS_ONBOARDING_TOUR_EXTRA_HIGHLIGHT_SELECTORS = [
    undefined,
    undefined,
    undefined,
    undefined,
    EMISSOR_ORDER_ACTIONS_TRIGGER_SELECTOR,
    undefined,
    undefined,
    undefined,
];
export const EMISSOR_BENEFITS_ONBOARDING_TOUR_CONFIG = {
    resolveTargetElementForStep: resolveEmissorBenefitsOnboardingTourTarget,
    extraHighlightSelectors: EMISSOR_BENEFITS_ONBOARDING_TOUR_EXTRA_HIGHLIGHT_SELECTORS,
    stepSelectors: EMISSOR_BENEFITS_ONBOARDING_TOUR_STEP_SELECTORS,
    stepCount: EMISSOR_BENEFITS_ONBOARDING_TOUR_STEP_SELECTORS.length,
    translationKeyPrefix: 'benefits.onboarding.emissor.tour',
    panelDefaultMaxWidthPx: 302,
    panelMaxWidthPx: [302, 302, 302, 302, 297, 297, 302, 302],
    panelHorizontalAlign: [
        'start',
        'start',
        'end',
        'end',
        'start',
        'start',
        'start',
        'center',
    ],
    panelPlacement: [
        'stack',
        'stack',
        'stack',
        'stack',
        'leading',
        'trailing',
        'stack',
        'stack',
    ],
    leadingVerticalAlign: [
        'center',
        'center',
        'center',
        'center',
        'start',
        'start',
        'center',
        'center',
    ],
    arrowXMode: [
        'panel-start',
        'panel-start',
        'hole-center',
        'hole-center',
        'hole-center',
        'hole-center',
        'panel-start',
        'hole-center',
    ],
};
